import { useEffect } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { useDispatch } from 'react-redux';
import { updateChromeConfiguration } from 'src/app/slice';
import { ChromeConfigurationChangeEvent } from 'src/commons/types';

// we can slowly deprecate this in favour of using ChromeConfigContextProvider
export const useChromeConfigurationListener = (): void => {
  const dispatch = useDispatch();
  const eventListenerFn = (event) => {
    // need to serialize object for redux actions
    const serializedObject = JSON.parse(
      JSON.stringify(event.detail.chromeConfiguration),
    );
    dispatch(updateChromeConfiguration(serializedObject));
  };
  useChromeConfigurationListenerWithCallback(eventListenerFn);
};

export const useChromeConfigurationListenerWithCallback = (
  callback: (event: ChromeConfigurationChangeEvent) => void,
): void => {
  useEffect(() => {
    AACChromeAPI.getCommonEventTarget().addEventListener(
      'ChromeConfigurationChange',
      callback,
    );

    return () => {
      AACChromeAPI.getCommonEventTarget().removeEventListener(
        'ChromeConfigurationChange',
        callback,
      );
    };
  }, []);
};
